import React from "react";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/swiper.min.css";
import { useTranslation } from "react-i18next";
import { Row } from "react-bootstrap";
import NoTemplate from "../../Assets/Animations/NoTemplate.json";
import LottiePlayer from "../LottiePlayer/lottiePlayer";

const NoTemplates = ({ list = false }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="d-flex flex-column text-black justify-content-center align-items-center">
        <Row className={`${list ? "w_16" : "w-100"} m-0 p-0`}>
          <LottiePlayer src={NoTemplate} />
        </Row>
        <Row className="w_max SFMedium text_18 ">{t("NoTemplateTitle")}</Row>
        <Row className="w_max SF mt-1 text_16">{t("NoTemplateSubTitle")}</Row>
      </div>
    </>
  );
};

export default NoTemplates;
